export { combineContainerMixins, makeCreateContainerFunction, createContainer } from "./create-container";


//////////////////
// WEBPACK FOOTER
// ./~/victory-create-container/es/index.js
// module id = ./node_modules/victory-create-container/es/index.js
// module chunks = 1